import { ShopApi } from "../../../common/constants/shop-api";
import environment from "../../../common/environment";
import { getResponseData } from "../../../common/utils/api-utils";
import { AddressBookMagentoResponse } from "../interfaces/address-book.interface";

/*----- API CALLS ------*/

export async function getAddressBookMagentoApiCall(token: string): Promise<AddressBookMagentoResponse> {
  const url = new URL(environment().magentoUrl + ShopApi.getAddressBookMagento);
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
  );
}
